import type { ReviewStatus } from "admin/types/interfaces/conversation";

/**
 * Review status options with display labels and colors for the admin UI.
 */
export const REVIEW_STATUS_OPTIONS: {
  value: ReviewStatus;
  label: string;
  color: string;
}[] = [
  {
    value: "UNREVIEWED",
    label: "Unreviewed",
    color: "bg-slate-100 text-slate-700 border-slate-300 hover:bg-slate-200",
  },
  {
    value: "REVIEWING",
    label: "Reviewing",
    color: "bg-blue-100 text-blue-700 border-blue-300 hover:bg-blue-200",
  },
  {
    value: "TICKETED",
    label: "Ticketed",
    color: "bg-purple-100 text-purple-700 border-purple-300 hover:bg-purple-200",
  },
  {
    value: "WONT_FIX",
    label: "Won't Fix",
    color: "bg-red-100 text-red-700 border-red-300 hover:bg-red-200",
  },
  {
    value: "RESOLVED",
    label: "Resolved",
    color: "bg-green-100 text-green-700 border-green-300 hover:bg-green-200",
  },
  {
    value: "NO_ACTION",
    label: "No Action",
    color: "bg-amber-100 text-amber-700 border-amber-300 hover:bg-amber-200",
  },
];

/**
 * Get the display label for a review status value.
 */
export const getReviewStatusDisplay = (status: ReviewStatus | undefined): string => {
  const option = REVIEW_STATUS_OPTIONS.find((opt) => opt.value === status);
  return option ? option.label : "Unreviewed";
};

/**
 * Get the color classes for a review status value.
 */
export const getReviewStatusColor = (status: ReviewStatus | undefined): string => {
  const option = REVIEW_STATUS_OPTIONS.find((opt) => opt.value === status);
  return option ? option.color : "bg-slate-100 text-slate-700 border-slate-300 hover:bg-slate-200";
};
